import { render, staticRenderFns } from "./MobileLoginV2.vue?vue&type=template&id=63d3ed5c&scoped=true"
import script from "./MobileLoginV2.vue?vue&type=script&lang=js"
export * from "./MobileLoginV2.vue?vue&type=script&lang=js"
import style0 from "./MobileLoginV2.vue?vue&type=style&index=0&id=63d3ed5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d3ed5c",
  null
  
)

export default component.exports